const module = { name: 'theater/details/desktop/closestTheaters', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const LIMIT = 7


const Selectors = {
    THEATER_ID: '.js-tdp',
    NEARBY_CONTAINER: '.js-closestTheaters-lazy',
    ERROR_ELS: '.js-closestTheaters-fail'
}


const DataAttributes = {
    THEATER_LAT: 'theater-lat',
    THEATER_LONG: 'theater-long'
}
function excludeCurrentTheater(theaters) {
    const currentTheaterId = $(Selectors.THEATER_ID).data().theaterId;
    const newData = theaters.filter((theater) => {
        if (currentTheaterId !== theater.id) {
            return theater;
        }
    });
    return newData;
}
function errorHandler() {
    $(Selectors.ERROR_ELS).addClass('hide');
}
function onFail(err) {
    debugLog.warn('nearTheatersFail', err);
    return errorHandler();
}
function onDone(data) {
    if (!data || data.error || !data.theaters) {
        return errorHandler();
    }
    const viewModel = excludeCurrentTheater(data.theaters);
    if (viewModel.length <= 1) {
        $(Selectors.NEARBY_CONTAINER).addClass('hide');
        $(Selectors.ERROR_ELS).addClass('hide');
        return;
    }
    if (viewModel.length === LIMIT) {
        viewModel.pop();
    }
    const $markup = $(swig.render('_closestTheaters', {
        theaters: viewModel
    }));
    $(Selectors.NEARBY_CONTAINER).html($markup);
}
function init() {
    xhr.ajax({
        method: 'GET',
        url: links.napiNearbyTheaters(),
        data: {
            limit: LIMIT,
            lat: $(Selectors.NEARBY_CONTAINER).data(DataAttributes.THEATER_LAT),
            long: $(Selectors.NEARBY_CONTAINER).data(DataAttributes.THEATER_LONG)
        },
    })
        .done(onDone)
        .fail(onFail);
}
module.exports = {
    init,
};
export default module.exports;